import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export function useResetEmployeePassword() {
  return useMutation({
    mutationFn: async (email: string) => {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/`,
      });
      if (error) throw error;
    },
  });
}
